import React from 'react';
import styles from './Defaults.less';
import { View, Text } from 'react-native';
import { BlockViewTitle } from 'root/globals/Elements';
import { withStyles } from '@material-ui/core/styles';
import BaseDialog from '@material-ui/core/Dialog';
import _ from 'root/libs/exaforte/react/lodash';

export const Dialog = withStyles({
    root: {
        '& .MuiDialog-paper': {
            padding: 24,
            paddingLeft: 20,
            paddingRight: 20,
            border: '0.6px solid #DFDFDF',
            borderRadius: 0,
            boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)',
            
            '@media only screen and (max-width: 575px)': {
                margin: 25,
                paddingTop: 22,
                paddingLeft: 18,
                paddingRight: 18,
                paddingBottom: 22
            }
        }
    }
})(BaseDialog);

export const CustomDialog = withStyles({
    root: {
        '& .MuiDialog-paper': {
            borderRadius: 0,
            borderTop: '5px solid #3dbbe2',
            padding: 32,
        },
        '& .MuiDialogTitle-root': {
            color: '#3dbbe2',
            padding: 0,
            '& h2': {
                border: '0 none',
                padding: 0,
                fontSize: 21,
                fontWeight: 'normal',
            },
        },
        '& .MuiDialogContent-root': {
            padding: 0,
            minWidth: 884,
            minHeight: 458,
        },
        '& .MuiTabs-flexContainer': {
            '& .MuiTab-root': {
                color: '#000',
                textTransform: 'initial',
                fontSize: 14,
                fontWeight: 400,
            },
            '& .Mui-selected': {
                fontWeight: 600,
            },
        },
        '& .MuiTabs-indicator': {
            backgroundColor: '#3dbbe2',
        },
        '& .MuiTabs-root': {
            borderBottom: '1px solid #e6e6e6',
        },
    },
})(BaseDialog);

export const MessageDialog = withStyles({
    root: {
        '& .MuiDialogContent-root': {
            minHeight: 'auto',
            minWidth: 'auto',
        },
    },
})(CustomDialog);

export const LoadingDialog = withStyles({
    root: {
        '& .MuiDialog-paper': {
            backgroundColor: 'transparent',
            border: '0 none',
            boxShadow: 'none',
        },
        '& .MuiDialogContent-root': {
            minHeight: 'auto',
            minWidth: 'auto',
            '& .MuiTypography-colorTextSecondary': {
                color: '#fff',
            },
        },
    },
})(CustomDialog);

export const ErrorDialogWrapper = withStyles({
    root: {
        '& .MuiDialog-paper': {
            borderTop: '5px solid #F95B5B'
        }
    }
})(Dialog);

export const WarningDialogWrapper = withStyles({
    root: {
        '& .MuiDialog-paper': {
            borderTop: '5px solid #FBA004'
        }
    }
})(Dialog);

export class ContentDialog extends React.Component {
    render() {
        let Wrapper = this.props.wrapper;
        let props   = _.filterSupportedProps(this.props, {open: true, onClose: true, maxWidth: true, fullWidth: true, fullScreen: true, scroll: true, 'aria-describedby': true, 'aria-labelledby': true});

        return (
            <Wrapper {...props}>
                <View className={['d-flex flex-row justify-content-between align-items-center mb-3 mb-sm-2', ...this.props.headerClassName]}>
                    <BlockViewTitle className={[styles['text-normal']]}>{this.props.title}</BlockViewTitle>
                    <View className={['d-' + (this.props.showActionsBreakpoint ? 'none d-' + this.props.showActionsBreakpoint + '-flex' : 'flex') + ' flex-row align-items-center']}>{this.props.actions}</View>
                </View>
                {this.props.description && (<Text className={['d-none d-sm-block font-weight-light mb-2', styles['f-1-2-5'], styles['color-dark-grey']]}>{this.props.description}</Text>)}
                {this.props.children}
            </Wrapper>
        );
    }
}
ContentDialog.defaultProps = {
    open: true,
    wrapper: Dialog,
    fullWidth: true,
    maxWidth: 'md',
    scroll: 'body',
    headerClassName: [],
}